import { Injectable } from '@angular/core';
import { HttpService } from '../helper/http.service';

@Injectable({
    providedIn: 'root'
})
export class ChartService {
    constructor(private httpService: HttpService) {}

    async getChartData(lang: string, todayTranslated: string): Promise<any> {
        return this.httpService._http('account', 'insights/chart-data', 'get', { params: { lang, todayTranslated } });
    }
    async getUserStats(): Promise<any> {
        return this.httpService._http('account', 'insights/active-users', 'get');
    }
}
